import React from 'react';

const QuestionCard = ({ learningObjective, answers, onAnswerClick, currentQuestionIndex, totalQuestions,
    selectedIndexx, questionSummary, questionFeedback, author, citations, ansClicked,
     isAnsCorrect, selectedOption, series }) => {
    return (
        <div className="question-section">
            <h3 className='queSr'> QUESTION {series} of {totalQuestions}</h3>
            {questionSummary.map((summary, index) => (
                <p key={'summary_' + index} className='summary' >{summary.content[0].value}</p>
            ))
            }
            <h3 className="question-lable">{learningObjective}</h3>
            <ul className="options">
                {answers.map((answer, index) => (
                    <li key={'li_' + index} className={(index == selectedIndexx && answer.isCorrect) ? 'active-qus correct' :(index == selectedIndexx && !answer.isCorrect) ? 'active-qus incorrect' :(ansClicked) ? 'd-none-qus ':''}>
                        <input type="radio"
                            id={'option_' + index + '_' + currentQuestionIndex}
                            style={{ backgroundColor: (index == selectedIndexx) ? '#9ef5ad' : 'transparent' }}
                            onChange={() => (!ansClicked) ? onAnswerClick(answer.isCorrect, true, index, questionFeedback , answer.ansvalue) : ''}
                            value={answer.ansvalue}
                            checked={selectedOption === answer.ansvalue}
                             />
                        <label htmlFor={'option_' + index + '_' + currentQuestionIndex}> {answer.text}</label>
                    </li>
                ))}
            </ul>
            {(ansClicked && isAnsCorrect) ?
                    <div className='auns-box'>
                        <div className="authores-content">
                            <div className='active-class'>
                                <p className="correct">CORRECT!</p>
                                {
                                    (questionFeedback) ? questionFeedback.map((f, index) => (
                                        <p key={'summary_' + index} >
                                            {
                                                (f.content.length > 1) ? f.content.map((ff, index) => 
                                                <span key={'span_'+index}>{ff.value}</span>
                                                ):f.content[0].value
                                            }
                                            </p>
                                    )) : ''
                                }

                            </div>
                            <div className='aut'>
                                <h3>Authors</h3>
                                {
                                    (author) ? author.map((au, index) => (
                                        <p key={'au_' + index} >{au.value}</p>
                                    )) : ''
                                }
                                <h3>Citations</h3>
                               
                                    {(citations) && citations.map((ct_p, index) => ( 
                                       
                                        <ul key={'ct_p_' + index}>
                                      { ct_p.content.map((ct, indexx) => (
                                        <li key={'ct_' + indexx} > {(ct.nodeType === 'text') ? ct.value : ''}
                                            {(ct.nodeType === 'hyperlink') ?
                                                <a href={ct.data.uri} target="_blank" rel="noopener noreferrer">{ct.content[0].value}</a> : ''}
                                        </li>
                                         ))
                                      }
                                      </ul>
                                     ))
                                    }
                                
                            </div>
                        </div>
                    </div>
                    : ''}
        </div>
    );
};

export default QuestionCard;